export const geoPoliticalUnitSelector = (state) => state.geopoliticalUnit;